import { themeConWeb } from '@app/util/modernThemeConweb'
import { Avatar, Box, Tooltip } from '@material-ui/core'
import cn from 'classnames'
import React from 'react'
import styled from 'styled-components'

import { getInitialsOrEmoji } from '../../util/formatUtils'

const Name = ({ email, firstName, lastName, showOnlyFirstName }) =>
  showOnlyFirstName && firstName
    ? firstName
    : firstName && lastName
    ? `${firstName != null ? firstName : ''} ${lastName != null ? lastName : ''}`
    : email || ''

export const YourLabel = ({ avatarId, classNames, isWebpSupported }) => {
  const webpSupported = isWebpSupported

  const imgSrc =
    avatarId && webpSupported !== undefined
      ? `${process.env.REACT_APP_IMAGE_LAMBDA}/profiles/${avatarId}.${
          webpSupported ? 'webp' : 'jpg'
        }?height=100&width=100`
      : ''

  return (
    <div className="circleContainer">
      <div className="labelOuter">
        {imgSrc ? (
          <img
            alt=""
            className={cn({
              ...classNames,
              'youCircle-profile-img': imgSrc,
            })}
            src={imgSrc}
          />
        ) : (
          <div className={cn(classNames)}>You</div>
        )}
      </div>
      <div
        className={cn({
          creditsProgressBarColor: classNames.youLabelColored,
          creditsProgressBarLong: true,
          leftRadius: true,
        })}
      />
    </div>
  )
}
// shows the user initials and first and last name
const FriendLabel = ({
  avatarId,
  classNames,
  email,
  firstName = '',
  friendLabelClasses,
  isWebpSupported,
  lastName = '',
  showEmail = true,
  showName = true,
  showOnlyFirstName,
  size = 'small',
  ...rest
}) => {
  const webpSupported = isWebpSupported

  const imgSrc =
    avatarId && webpSupported !== undefined
      ? `${process.env.REACT_APP_IMAGE_LAMBDA}/profiles/${avatarId}.${
          webpSupported ? 'webp' : 'jpg'
        }?height=100&width=100`
      : ''

  const avatarClassName = cn({
    'MuiAvatar-circular--large': size === 'large',
    'MuiAvatar-circular--medium': size === 'medium',
    'MuiAvatar-circular--small': size === 'small',
  })

  const name = firstName && lastName && `${firstName} ${lastName}`

  return (
    <Component className={cn(friendLabelClasses, 'friendsLabel')} {...rest}>
      <Tooltip title={name || email}>
        <Box display="flex" justifyContent="center">
          <Avatar className={avatarClassName} name={name || email} src={imgSrc} variant="circular">
            {name && getInitialsOrEmoji(name)}
          </Avatar>
        </Box>
      </Tooltip>
      {(showName || showEmail) && (
        <div className="friendDetails">
          <div>
            {showName && (
              <Name
                {...{
                  email,
                  firstName,
                  lastName,
                  showOnlyFirstName,
                }}
              />
            )}
            {showEmail && <div className="friendEmail">{email}</div>}
          </div>
        </div>
      )}
    </Component>
  )
}

const Component = styled.div`
  margin: 0 0 4px 0;
  display: flex;
  width: 100%;

  & .MuiAvatar-circular {
    &--small {
      height: calc(${themeConWeb.baseUnit} * 10);
      width: calc(${themeConWeb.baseUnit} * 10);
      font-size: ${themeConWeb.fontSizes.basePlus2};
    }

    &--medium {
      height: calc(${themeConWeb.baseUnit} * 15);
      width: calc(${themeConWeb.baseUnit} * 15);
      font-size: ${themeConWeb.fontSizes.basePlus4};
    }

    &--large {
      height: calc(${themeConWeb.baseUnit} * 20);
      width: calc(${themeConWeb.baseUnit} * 20);
      font-size: ${themeConWeb.fontSizes.basePlus5};
    }
  }
`

export default FriendLabel
